module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_qualify_banner_variant5_image-ee871fe78c3c90e7d74c1fdedf868397.jpg";